import { render, staticRenderFns } from "./module_group.vue?vue&type=template&id=2a549f80&scoped=true&"
import script from "./module_group.vue?vue&type=script&lang=js&"
export * from "./module_group.vue?vue&type=script&lang=js&"
import style0 from "./module_group.vue?vue&type=style&index=0&id=2a549f80&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a549f80",
  null
  
)

export default component.exports